import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=161d088d&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161d088d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('161d088d')) {
      api.createRecord('161d088d', component.options)
    } else {
      api.reload('161d088d', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=161d088d&scoped=true&", function () {
      api.rerender('161d088d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nnrJQgp8g5lq/JS/comp/Voucher-Unit.vue"
export default component.exports